import React, { useState } from 'react';
import { MailIcon, CheckIcon, AlertCircleIcon } from 'lucide-react';
import { addDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../services/firebase';
const EmailSubscribe: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const validateEmail = (email: string) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // Reset states
    setError(null);
    setSuccess(false);
    // Validate email
    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }
    setLoading(true);
    try {
      // Check if email already exists
      const subscribersRef = collection(db, 'subscribers');
      const q = query(subscribersRef, where('email', '==', email));
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        setError('This email is already subscribed');
        setLoading(false);
        return;
      }
      // Add new subscriber
      await addDoc(collection(db, 'subscribers'), {
        email,
        createdAt: new Date(),
        active: true
      });
      setSuccess(true);
      setEmail('');
    } catch (err) {
      console.error('Error subscribing:', err);
      setError('Failed to subscribe. Please try again later.');
    } finally {
      setLoading(false);
    }
  };
  return <div className="bg-navy text-white p-6 rounded-lg" data-id="element-60">
      <div className="flex items-center mb-4" data-id="element-61">
        <MailIcon size={24} className="mr-2" data-id="element-62" />
        <h3 className="text-xl font-bold font-montserrat" data-id="element-63">
          Subscribe to eNews
        </h3>
      </div>
      <p className="mb-4" data-id="element-64">
        Get the latest articles, success stories, and updates delivered to your
        inbox.
      </p>
      {success ? <div className="bg-green-800 text-white p-4 rounded-md flex items-center" data-id="element-65">
          <CheckIcon size={20} className="mr-2 flex-shrink-0" data-id="element-66" />
          <span data-id="element-67">
            Thank you for subscribing! You'll receive our next update.
          </span>
        </div> : <form onSubmit={handleSubmit} data-id="element-68">
          {error && <div className="bg-red-800 text-white p-3 rounded-md mb-4 flex items-center" data-id="element-69">
              <AlertCircleIcon size={18} className="mr-2 flex-shrink-0" data-id="element-70" />
              <span data-id="element-71">{error}</span>
            </div>}
          <div className="flex flex-col sm:flex-row gap-2" data-id="element-72">
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Your email address" className="flex-1 px-4 py-2 rounded-md text-gray-800 focus:outline-none focus:ring-2 focus:ring-orange" required data-id="element-73" />
            <button type="submit" className="bg-orange hover:bg-orange-600 text-white font-bold py-2 px-6 rounded-md transition duration-300" disabled={loading} data-id="element-74">
              {loading ? 'Subscribing...' : 'Subscribe'}
            </button>
          </div>
          <p className="mt-3 text-sm text-gray-300" data-id="element-75">
            We respect your privacy. Unsubscribe at any time.
          </p>
        </form>}
    </div>;
};
export default EmailSubscribe;